import React, { useEffect, useState, useContext, Fragment } from "react";
import SharedDataContext from "../../../_helper/SharedData";
import InvoicesTable from "./InvoicesTable";
import { showAlert } from "../../../Services/Shared.service";
import { Breadcrumbs, Btn, CommonModal } from "../../../AbstractElements";
import { Row, Col, Card, CardBody, Container, Modal, ModalBody, Nav, NavItem, NavLink } from "reactstrap";
import { confirmationOtp, getInvoiceCorrectionsList, submitDutyRegister } from "../../../Services/InvoiceCorrection.service";
import { Slash } from "react-feather";

const InvoiceList = () => {
    const { cityData, globalCityField, setShowApiLoader } =
        useContext(SharedDataContext);
    const [tableData, setTableData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [pagination, setPagination] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [selectedTrips, setSelectedTrips] = useState([])
    const [isAllChecked, setIsAllChecked] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [otp, setOtp] = useState("")

    const onChangePage = (page) => {
        console.log("page", page);
        setPagination(page - 1);
    };

    const onChangeRowsPerPage = (currentRowsPerPage) => {
        setRowsPerPage(currentRowsPerPage);
    };

    useEffect(() => {
        fetchTableData();
    }, [globalCityField.value, pagination, rowsPerPage]);

    const fetchTableData = () => {
        const serviceCityId = globalCityField.value?.id || 0;
        let obj = {
            serviceCityId: serviceCityId,
            page: pagination,
            size: rowsPerPage,
        };
        setLoader(true);
        getInvoiceCorrectionsList(obj)
            .then((result) => {
                setPaginationTotalRows(result.data.count);
                setTableData(result.data.list);
                disableLoaders();
            })
            .catch((err) => {
                disableLoaders();
                showAlert("error", err.response?.data?.message
                    ? err.response.data.message : "Something went wrong");
            });
    };
    const disableLoaders = () => {
        setLoader(false);
        // setShowApiLoader(false);
    };

    const handleSelectTrip = (flag, tripId) => {
        if (!selectedTrips.includes(tripId)) {
            let newSelectedTrips = [...selectedTrips]
            newSelectedTrips.push(tripId)
            setSelectedTrips(newSelectedTrips)
        } else {
            let newSelectedTrips = selectedTrips.filter((trip) => trip !== tripId)
            setSelectedTrips(newSelectedTrips)
        }
    }

    const handleSelectAllTrips = (flag) => {
        if (!isAllChecked) {
            let newSelectedTrips = []
            tableData.map((data) => {
                newSelectedTrips.push(data.tripId)
            })
            setSelectedTrips(newSelectedTrips)
            setIsAllChecked(true)
        } else {
            setSelectedTrips([])
            setIsAllChecked(false)
        }
    }

    const sendOtp = () => {
        let obj = {
            mobileNo: null,
            deviceId: null,
            deviceType: null
        }
        confirmationOtp(obj).then((result) => {
            showAlert("success", "Confirmation OTP send your mobile, Please check it.")
            setIsModalOpen(!isModalOpen)
        }).catch((err) => {
            showAlert("error", err.response?.data?.message
                ? err.response.data.message : "Something went wrong");
        });
    }

    const validateOtp = () => {
        let obj = {
            mobileNo: null,
            deviceId: null,
            deviceType: null,
            otp: otp
        }
        confirmationOtp(obj).then((result) => {
            onSubmitRegister();
        }).catch((err) => {
            showAlert("error", err.response?.data?.message
                ? err.response.data.message : "Something went wrong");
        });
    }

    const onSubmitRegister = () => {
        let submitObj = {
            tripIdList: selectedTrips
        }
        submitDutyRegister(submitObj).then(() => {
            showAlert("success", "Successfully Updated Trip Invoice Correction List.")
            // setIsModalOpen(!isModalOpen)
            setSelectedTrips([])
            fetchTableData()
        }).catch((err) => {
            showAlert("error", err.response?.data?.message
                ? err.response.data.message : "Something went wrong");
        });
    }

    console.log("selected trips", selectedTrips)

    return (
        <Fragment>
            <Breadcrumbs
                parent="Configuration"
                subParent="Invoice List"
                mainTitle="Invoice List"
                //   span1={
                //     <FilterTable
                //       options={columns}
                //       setFilterData={setFilterData}
                //       filterData={filterData}
                //       setSearchData={setSearchData}
                //       setFilterType={setFilterType}
                //       statusData={bookingStatusData}
                //       bookingViaTypeData={bookingViaTypeData}
                //     />
                //   }
                span3={
                    <Btn attrBtn={{
                        color: "primary", style: { display: "flex", padding: "7px 14px", justifyContent: "center", alignItems: "center" },
                        onClick: () => {
                            if (selectedTrips.length == 0) {
                                showAlert("error", "Please select updated Trip Invoice Correction List.")
                                return
                            }
                            onSubmitRegister()
                        }
                    }}>
                        Submit to Duty Register
                    </Btn>
                }
            />
            <Container fluid={true} className="datatables">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-0">
                                    <InvoicesTable
                                        fetchTableData={fetchTableData}
                                        tableData={tableData}
                                        setShowApiLoader={setLoader}
                                        onChangePage={onChangePage}
                                        paginationPerPage={rowsPerPage}
                                        paginationTotalRows={paginationTotalRows}
                                        onChangeRowsPerPage={onChangeRowsPerPage}
                                        selectedTrips={selectedTrips}
                                        handleSelectTrip={handleSelectTrip}
                                        handleSelectAllTrips={handleSelectAllTrips}
                                        isAllChecked={isAllChecked}
                                        loader={loader}
                                    />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <CommonModal
                isOpen={isModalOpen}
                title={"Update Trip Invoice Correction"}
                toggler={() => setIsModalOpen(!isModalOpen)}
                size="md"
            >
                <Row className="driver-push-notification">
                    <Col xl="12" className="push-botification-body">
                        <div className="text-center">Please enter Confirmation OTP</div>
                    </Col>
                    <Col className="push-notification-footer">
                        <input type="text" className="form-control" style={{ width: "30% !important" }} value={otp} onChange={(e) => setOtp(e.target.value)} />
                        <button
                            className="btn btn-primary"
                            type="submit"
                            style={{ margin: "0px 20px" }}
                            onClick={validateOtp}
                        >
                            Submit
                        </button>
                        <button
                            className="btn btn-primary"
                            type="submit"
                            onClick={() => setIsModalOpen(!isModalOpen)}
                            style={{ display: "flex", alignItems: "center" }}
                        >
                            <Slash size={"16px"} style={{ marginRight: "5px" }} /> Cancel
                        </button>
                    </Col>
                </Row>
            </CommonModal>
        </Fragment>
    );
};

export default InvoiceList;
